import React from 'react';
import classnames from 'classnames';

export default class Indicator extends React.Component {

  render() {
    const className = classnames(
      this.props.className,
      'Indicator',
      {
        'Indicator--light': this.props.light,
        'Indicator--large': this.props.large
      }
    );
    return (
      <div className={className} />
    );
  }

}



// WEBPACK FOOTER //
// ./src/components/Indicator.js